import { useRef, useState } from 'react';
import useAuth, { useSetUser } from '../../../utils/auth';
import useToastStore from '../../../components/app-layout/toastStore';
import PostHmrcDataToggle from '../../../services/adapters/hmrcDataToggle';
import { HmrcDataBranchValues } from '../../../types/core.type';
import useHmrcDataToggle from '../hooks/useHmrcDataToggle';
import HmrcDataToggle from '../components/HmrcDataToggle';

const errorMessage = "Couldn't change the HMRC data setting. Please try again.";

export default function HmrcDataToggleContainer({ isExpanded, onExpand }: Readonly<{
  isExpanded: boolean,
  onExpand: () => void,
}>) {
  const user = useAuth();
  const setUser = useSetUser();
  const { isVisible, isOn: isInitiallyOn, tooltip } = useHmrcDataToggle();
  const [isOn, setIsOn] = useState(isInitiallyOn);
  const isRequestPending = useRef(false);

  if (!isVisible) {
    return null;
  }

  const changeBranch = async (isNextOn: boolean) => {
    if (isRequestPending.current) {
      return;
    }
    isRequestPending.current = true;
    setIsOn(isNextOn);
    try {
      const hmrcDataToggle = await new PostHmrcDataToggle()
        .adaptResponse(isNextOn ? HmrcDataBranchValues.On : HmrcDataBranchValues.Off);
      setUser({ ...user, hmrcDataToggle });
    } catch {
      setIsOn(!isNextOn);
      useToastStore.getState().showToast(errorMessage, 'error');
    } finally {
      isRequestPending.current = false;
    }
  };

  return (
    <HmrcDataToggle
      isOn={isOn}
      isExpanded={isExpanded}
      tooltip={tooltip}
      onChange={(isNextOn) => { void changeBranch(isNextOn); }}
      onExpand={onExpand}
    />
  );
}
